// extracted by mini-css-extract-plugin
module.exports = {"option":"OptionSelect_option__1ti3I","desabilitar":"OptionSelect_desabilitar__1JrNu","focado":"OptionSelect_focado__Kxf-s","novo":"OptionSelect_novo__1LWGM"};